export const environment = {
    apiServer: 'https://umw-ecom-dev-api.agmo.studio',
    env: 'development',
    domainUrl: 'https://umw-ecom-dev-web.agmo.studio',
    recaptchaKey: '6Lex_kMsAAAAAMs-pBz_wa6JrOVDX4F836mibItS',
    gaMeasurementId: 'G-NNWFMKZVBN',
    msalConfig: {
        auth: {
            clientId: '41a93796-d70a-4434-a86b-fdaef317ea31',
            authority: 'https://login.microsoftonline.com/common',
        },
    },
    apiConfig: {
        scopes: ['user.read', 'profile', 'openid', 'email'],
        uri: 'https://graph.microsoft.com/v1.0/me',
    },
    msalSecret: {
        secretKey: '6mG8Q~CgThm8XHF.kik4R_CIFgMzlDKsQzkEWcn0',
        secretId: 'd99afdbd-c257-4f1b-af84-65219668026b',
    },
    firebase: {
        apiKey: 'AIzaSyBc-I7w5gB0l60CA2mygOAMJ8IGEoyoQHs',
        authDomain: 'fir-umw-forklift-rental-ecom.firebaseapp.com',
        projectId: 'fir-umw-forklift-rental-ecom',
        storageBucket: 'fir-umw-forklift-rental-ecom.firebasestorage.app',
        messagingSenderId: '72458817012',
        appId: '1:72458817012:web:1845d8febecbad80fe3da1',
        measurementId: 'G-7NTFRHN4W9',
    },
    publicKey:
        '-----BEGIN PUBLIC KEY----- MIGJAoGBAMITRmTe88FiK87o8ATZdlHiLZYWb7At8eiZ/JS/4obUsExBopsJPFZn/lItErwhB73SWOkFPxZgs9IznpEgHs654wiqSiAub+VFpOvm4Whue3kEC7HMnp7Gpyd0ixDl+yDX53NzqKmN+tnj/ifFfPsGwroCwZ2Cpa9Iy1sZ1/3NAgMBAAE= -----END PUBLIC KEY-----',
};
